// src/components/Header.jsx
import React, { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import Offcanvas from "./Offcanvas.jsx";

const withBase = (p) =>
  `${import.meta.env.BASE_URL}${String(p || "").replace(/^\//, "")}`;

const Header = () => {
  const [activateOffcanvas, setActivateOffcanvas] = useState(false);

  const toggleOffcanvas = useCallback(() => {
    setActivateOffcanvas((v) => !v);
  }, []);

  const handleOffcanvasStatus = useCallback((status) => {
    setActivateOffcanvas(status);
  }, []);

  return (
    <header>
      <style>{`
        :root{
          --brand:#107b49;
          --brand-2:#0fb66e;
          --ink:#0f172a;
          --border:#d8e6de;
          --ring:rgba(16,123,73,.18);
          --shadow: 0 10px 24px rgba(2,6,23,.06);
        }

        /* Header spacing — reduced */
        .header-wrapper{
          padding: 6px 0 10px; /* ⬅ was 10px 0 18px */
          background:
            radial-gradient(1100px 700px at 10% -10%, rgba(16,123,73,.05), transparent 60%),
            radial-gradient(900px 500px at 95% 110%, rgba(15,182,110,.05), transparent 60%),
            linear-gradient(180deg, #f6fbf8 0%, #ffffff 100%);
        }

        /* App bar height — reduced */
        .appbar{
          display:grid;
          grid-template-columns: 40px 1fr 40px;
          align-items:center;
          gap: 8px;
          min-height: 48px; /* ⬅ was 56–58px */
        }

        /* Logo box — tighter */
        .logo-box{
          display:inline-flex;
          align-items:center;
          justify-content:center;
          padding: 6px 10px; /* ⬅ was 10px 14px */
          border-radius: 14px;
          border: 1px solid rgba(16,123,73,.14);
          background: linear-gradient(
            180deg,
            rgba(16,123,73,.06),
            transparent
          );
          box-shadow: 0 6px 16px rgba(2,6,23,.06);
        }

        /* Logo image — slightly smaller */
        .logo-img{
          height: 34px; /* ⬅ was 42px */
          width: auto;
          max-width: 200px;
          object-fit: contain;
          display:block;
        }

        /* Hamburger button — compact */
        .header-menu-trigger{
          width: 36px;   /* ⬅ was 40–42px */
          height: 36px;
          border-radius:10px;
        }

        /* Mobile */
        @media (max-width: 480px){
          .header-wrapper{ padding-bottom: 8px; }
          .appbar{ min-height: 44px; }
          .logo-img{ height: 30px; }
          .logo-box{ padding: 5px 8px; }
        }

        /* Large screens */
        @media (min-width: 1200px){
          .appbar{ min-height: 52px; }
          .logo-img{ height: 38px; }
        }

      `}</style>

      <div className="header-wrapper">
        <div className="container space-y--15">
          <div className="appbar">
            <div aria-hidden="true" />

            {/* ✅ LOGO WITH ITS OWN BOX */}
            <div className="appbar__logo">
              <Link to="/dashboard" aria-label="Go to dashboard">
                <div className="logo-box">
                  <img
                    src={withBase("logonew.jpeg")}
                    alt="Share My Venture"
                    className="logo-img"
                  />
                </div>
              </Link>
            </div>

            <div className="appbar__actions">
              <button
                type="button"
                className="header-menu-trigger"
                onClick={toggleOffcanvas}
                aria-label="Open menu"
              >
                <ReactSVG src={withBase("assets/img/icons/menu.svg")} />
              </button>
            </div>
          </div>
        </div>
      </div>

      <Offcanvas show={activateOffcanvas} activeStatus={handleOffcanvasStatus} />
    </header>
  );
};

export default Header;
